import ACTIONS from "./action";
import data from "../data";

const defaultState = {
    genericInk: true,
    highYieldInk: true,
    selectedPrinter: 1,
    recommendedPlan: data.plans[3],
    selectedPlan: data.plans[3],
    annualInkSavings: 0.00,
    panicTrips: 3,
    reducedCarbonFootprint: 84,
    pagesPerMonth: 100,
    estimatedInkCostPerYear: 0.00,
    estimatedInkCostPerMonth: 7.84,
    estimatedColorInk: 2,
    estimatedBlackInk: 3,
    blackAndWhiteOnly: false,
};

const printerReducer = (state = defaultState, action) => {
    switch (action.type) {
        case ACTIONS.Types.CHANGE_PAGES:
            {
                let pagesPerMonth = action.payload;

                return {
                    ...state,
                    pagesPerMonth
                };
            }
        case ACTIONS.Types.CHANGE_PLAN:
            {
                let selectedPlan = action.payload;

                return {
                    ...state,
                    selectedPlan
                };
            }
        case ACTIONS.Types.CHANGE_ANNUAL_COST:
            {
                let estimatedInkCostPerYear = action.payload;

                return {
                    ...state,
                    estimatedInkCostPerYear
                };
            }
        case ACTIONS.Types.CHANGE_MONTHLY_COST:
            {
                let estimatedInkCostPerMonth = action.payload;

                return {
                    ...state,
                    estimatedInkCostPerMonth
                };
            }
        case ACTIONS.Types.CHANGE_COLOR_INK:
            {
                let estimatedColorInk = action.payload;

                return {
                    ...state,
                    estimatedColorInk
                };
            }
        case ACTIONS.Types.CHANGE_BLACK_INK:
            {
                let estimatedBlackInk = action.payload;

                return {
                    ...state,
                    estimatedBlackInk
                };
            }
        case ACTIONS.Types.CHANGE_ANNUAL_SAVINGS:
            {
                let annualInkSavings = action.payload;

                return {
                    ...state,
                    annualInkSavings
                };
            }
        case ACTIONS.Types.CHANGE_PANIC_TRIPS:
            {
                let panicTrips = action.payload;

                return {
                    ...state,
                    panicTrips
                };
            }
        case ACTIONS.Types.CHANGE_INK_TYPE:
            {
                let inkType = action.payload;

                let blackAndWhiteOnly = inkType === 'black';

                return {
                    ...state,
                    blackAndWhiteOnly
                };
            }
        case ACTIONS.Types.CHANGE_HIGH_YIELD_INK:
            {
                let highYieldInk = action.payload;

                return {
                    ...state,
                    highYieldInk
                };
            }
        case ACTIONS.Types.CHANGE_GENERIC_INK:
            {
                let genericInk = action.payload;

                return {
                    ...state,
                    genericInk
                };
            }

        default:
            return state;
    }
};

export default printerReducer;
